module.exports = __webpack_public_path__ + "static/img/lumbarPainMan_2.17ace461.png";